import { useEffect, useRef } from 'react'

interface IUseEntityViewTracking {
  inViewPort?: boolean
  exitObserve?: boolean
  setViewed: () => void
  setUnViewed: () => void
  setUnViewedWaiting?: () => void
  needViewed?: boolean
  courseFinished?: boolean
}

export const useEntityViewTracking = ({
  inViewPort,
  exitObserve,
  setViewed,
  setUnViewed,
  needViewed,
  setUnViewedWaiting,
  courseFinished,
}: IUseEntityViewTracking) => {
  // first render send 'statement event' even all elements viewed false
  const currentState = useRef<'entered' | 'exited' | null>(null)

  //:TODO TMP think about move on back or storage data section and block in redux. When course ends (e.g. "completed" button) the block may not unmount
  useEffect(() => {
    if (courseFinished && currentState.current === 'entered') {
      currentState.current = 'exited'
      setUnViewed()
    }
  }, [courseFinished, setUnViewed])

  useEffect(() => {
    if (!needViewed) {
      return
    }

    const abortController = new AbortController()
    const { signal } = abortController

    const handleVisibilityChange = (_e: BeforeUnloadEvent) => {
      if (!exitObserve) {
        return
      }
      const isHidden = document.visibilityState === 'hidden'
      if (isHidden) {
        setUnViewed()
      } else {
        setViewed()
      }
    }

    const handleExit = (_e: BeforeUnloadEvent) => {
      if (!exitObserve || !setUnViewedWaiting) {
        return
      }
      setUnViewedWaiting()
    }

    if (inViewPort && currentState.current !== 'entered') {
      currentState.current = 'entered'
      setViewed()
    } else if (!inViewPort && currentState.current === 'entered') {
      currentState.current = 'exited'
      setUnViewed()
    }
    // window.addEventListener('beforeunload', handleExit, { signal })
    window.addEventListener('pagehide', handleExit, { signal })
    window.addEventListener('visibilitychange', handleVisibilityChange, { signal })
    return () => {
      if (currentState.current === 'entered') {
        currentState.current = 'exited'
        setUnViewed()
      }
      abortController.abort()
    }
  }, [inViewPort, setViewed, setUnViewed, needViewed, setUnViewedWaiting, exitObserve])
}
